import { Box, ColorOptions, convertHexToRGBA, Text } from '@jfs/ui-new'
import { useEffect } from 'react'
import { Colors } from '../../../util/util'

export const TabBar = ({ state, descriptors, navigation, onTabChange }: any) => {
  return (
    <Box
      bg={'WHITE'}
      flexDirection={'row'}
      borderBottomWidth={1}
      borderBottomColor={convertHexToRGBA(Colors.BLACK, 12) as ColorOptions}
      ph={24}>
      {state?.routes?.map((route, index) => {
        const { options } = descriptors[route.key]
        const label =
          options.tabBarLabel !== undefined
            ? options.tabBarLabel
            : options.title !== undefined
            ? options.title
            : route.name

        const isFocused = state.index === index

        const onPress = () => {
          const event = navigation.emit({
            type: 'tabPress',
            target: route.key,
            canPreventDefault: true,
          })

          if (!isFocused && !event.defaultPrevented) {
            navigation.navigate(route.name)
          }
        }

        useEffect(() => {
          if (isFocused) {
            onTabChange(index)
          }
        }, [isFocused])
        return (
          <Box
            accessibilityLabel={options.tabBarAccessibilityLabel}
            testID={options.tabBarTestID}
            onPress={onPress}
            align={'center'}
            justify={'center'}
            h={48}
            ph={8}
            mr={16}
            underlayColor={'GRAY_BORDER'}
            borderBottomWidth={isFocused ? 2 : 0}
            borderBottomColor={isFocused ? 'PRIMARY' : 'DISABLED_GREY'}
            bg={'WHITE'}>
            <Text
              color={isFocused ? 'PRIMARY' : (Colors.BLACK_14 as ColorOptions)}
              fontSize={14}
              lineHeight={20}
              letterSpacing={-0.07}
              fontFamily={isFocused ? 'JioType-Bold' : 'JioType-Medium'}>
              {label}
            </Text>
          </Box>
        )
      })}
    </Box>
  )
}
